<template>
  <div class="events">
    <Timeline />
    <Present />
    <template
      v-for="(year, i) in Object.keys(events).sort((a, b) => b - a)"
    >
      <TimelineYear
        v-bind:timeline-year-class="i ? '' : 'timeline-year--first'"
        v-if="events[year].length"
        v-bind:year="year"
      />
      <template
        v-for="(event, j) in events[year]"
      >
        <div v-bind:id="event.id" />
        <Event
          v-bind:event-class="`${i+j ? '' : 'event--first'}${i === Object.keys(events).length-1 && j === events[year].length-1 ? 'event--last': ''}`"
          v-bind:event="event"
        />
      </template>
    </template>
  </div>
</template>

<script>
import Event from '@/components/Event';
import Timeline from '@/components/Timeline';
import TimelineYear from '@/components/TimelineYear';
import Present from '@/components/Present';

export default {
  name: 'Events',
  components: {
    Event,
    Timeline,
    TimelineYear,
    Present,
  },
  props: {
    events: {
      type: Object,
      required: true,
    },
    scrollToId: String,
  },
};
</script>

<style lang="scss">
@import '@/styles/functions.scss';

.events {
  position: relative;

  a:hover{
    color: #80ce1b;
  }

  .timeline {
    position: absolute;
    top: 0;
    left: 3px;
  }

  .event {
    margin-bottom: 90px;

    &--first {
      .timeline-event,
      .event__detail {
        margin-top: 50px;
      }
    }

    &--last {
      margin-bottom: 0;

      .event__detail {
        padding-bottom: 90px;
      }

      .timeline-event {
        margin-top: -90px;
      }
    }
  }

  .timeline-year {
    margin-bottom: 90px;
    margin-left: 32px;

    &--first {
      display: none;
    }
  }

  .present {
    display: none;
  }

  @include media-breakpoint-up(md) {
    .timeline {
      left: 14px;
    }

    .event {
      margin-bottom: 120px;

      &--last {
        margin-bottom: 56px;
      }
    }

    .timeline-year {
      margin-bottom: 145px;
      margin-left: 65px;
    }
  }

  @include media-breakpoint-up(lg) {
    margin: 0 auto;
    max-width: 972px;

    .event {
      margin-bottom: 145px;

      &--first {
        .timeline-event,
        .event__detail {
          margin-top: 123px;
        }
      }

      &--last {
        margin-bottom: 86px;

        .event__detail {
          padding-bottom: 100px;
        }
      }
    }

    .timeline-year {
      transform: rotate(270deg);
      position: absolute;
      left: -198px;
      margin-top: 28px;

      &--first {
        display: block;
        margin-top: 150px;
      }
    }

    .present {
      display: inline-block;
      position: absolute;
      left: 15px;
      transform: translate(-50%, -100%);
      top: 0;
    }
  }

  @include media-breakpoint-up(xl) {
    .event {
      &--last {
        margin-bottom: 90px;

        .event__detail {
          padding-bottom: 220px;
        }
      }
    }
  }
}
</style>
